import React, { useEffect, useState } from "react";
import {
  AppBar,
  Button,
  List,
  ListItem,
  Stack,
  styled,
  SvgIcon,
  Toolbar,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ReactComponent as SogLogo } from "../../../assets/svgs/sog-logo.svg";
import { PARENT_MENU_LIST, SCRIPT_MENU_LIST } from "./HeaderMenuLists";

const StyledButton = styled((props) => (
  <Button LinkComponent={Link} disableRipple {...props} />
))(() => ({
  "&.MuiButtonBase-root": {
    color: "#808385",
    lineHeight: "20px",
    letterSpacing: "0.02em",
    textTransform: "capitalize",
    mixBlendMode: "normal",
    "&:hover": {
      background: "transparent",
    },
  },
}));

const StyledMenu = styled((props) => <List {...props} />)(() => ({
  "&.MuiList-root": {
    borderRadius: 12,
    whiteSpace: "nowrap",
    minWidth: 165,
    background: "#FFFFFF",
    position: "absolute",
    boxShadow:
      "0px 0px 1px rgba(0, 0, 0, 0.08), 0px 3px 4px rgba(0, 0, 0, 0.04), 0px 4px 10px rgba(30, 136, 250, 0.12)",

    "& .MuiListItem-root": {
      color: "rgba(43, 49, 51, 0.88)",
      padding: "14px 16px",
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: "400",

      "&:hover": {
        background: "rgba(0, 0, 0, 0.04)",
      },
    },
  },
}));

const HeaderWeb = ({ currentPage }) => {
  const [menuList, setMenuList] = useState([]);
  const [activeMenu, setActiveMenu] = useState(currentPage);
  const handleHover = (menuName) => {
    switch (menuName) {
      case "Scripts":
        setMenuList(SCRIPT_MENU_LIST);
        break;
      default:
        setMenuList([]);
        break;
    }
  };

  useEffect(() => {
    setActiveMenu(currentPage);
  }, [currentPage]);

  return (
    <>
      <AppBar
        component={"nav"}
        position="fixed"
        className="sog-web-header"
        sx={{
          backgroundColor: "#FFFFFF",
          boxShadow: "none",
          top: 0,
          zIndex: 999,
        }}
      >
        <Toolbar
          sx={{
            height: "72px",
            paddingTop: "7px",
            paddingBottom: "5px",
            width: "83%", // use percentage width
            margin: "0 auto", // center it horizontally
            justifyContent: "space-between",
          }}
        >
          <div className="header-logo">
            <ListItem component={Link} to={"/home"}>
              <SvgIcon component={SogLogo} inheritViewBox />
            </ListItem>
          </div>
          <Grid container justifyContent="flex-end">
            <Stack
              direction="row"
              spacing={3}
              ml={3}
              height={"100%"}
              flexGrow={1}
            >
              {PARENT_MENU_LIST.map((item) => {
                return (
                  <div
                    key={`sog-dropdown-${item.label}}`}
                    className={
                      item.hasPopUp ? "sog-dropdown has-menu" : "sog-dropdown"
                    }
                    onMouseOver={() => handleHover(item.label)}
                  >
                    <StyledButton
                      className={
                        activeMenu === item.label ? "header-active-menu" : ""
                      }
                      startIcon={
                        <SvgIcon component={item.iconPath} inheritViewBox />
                      }
                      onClick={() => {
                        if (!item.hasPopUp) {
                          setActiveMenu(item.label);
                        }
                      }}
                      to={item.hrefLink}
                    >
                      {item.label}
                    </StyledButton>
                    <StyledMenu className="dropdown-menu">
                      {menuList.map((menuItem) => {
                        return (
                          <ListItem
                            component={Link}
                            to={menuItem.url}
                            key={`sog-menu-item-${menuItem.title}}`}
                            onClick={() => setActiveMenu(menuItem.parentMenu)}
                          >
                            {menuItem.title}
                          </ListItem>
                        );
                      })}
                    </StyledMenu>
                  </div>
                );
              })}
            </Stack>
          </Grid>
          {["PreLoginAcctStatment"].includes(currentPage) && (
            <div
              onClick={() =>
                (window.location.href =
                  "https://ntrade.kotaksecurities.com/Login")
              }
              className={"prelogin-acct-login"}
            >
              Account Login
            </div>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default HeaderWeb;
